"use client";
import { motion } from "framer-motion";
import Select from "react-select";
import React, { useEffect, useState } from "react";
import Link from "next/link";
import SectionHeading from "./SectionHeading/SectionHeading";
import { articleService } from "@/services/articleService";
import { BroFormData } from "@/types/common";
import { getNames } from "country-list";
import InputField from './CustomInput';
import { useForm } from 'react-hook-form';

// const countries = [
//   { value: "ME", label: "ME" },
//   { value: "G", label: "Global" },
//   { value: "AU", label: "Australia" },
//   { value: "IN", label: "India" },
// ];
export default function BroForm({
  post_id,
  brand_id,
  setIsSubmitted,
}: {
  post_id?: number;
  brand_id?: number;
  setIsSubmitted: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const [countryList, setCountryList] = useState<
    { label: string; value: string }[]
  >([]);
  const [isSubmitting,setIssubmitting] = useState<boolean>(false);

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    control,
    formState: { errors, isValid }
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      email: '',
      mobile: '',
      fname: '',
      lname: '',
      company_name: '',
      country_name: '',
      designation: '',
      fk_country_id: '',
      is_subscribe_news_letter: true,
      is_accept_terms: false,
    }
  });

  const values = watch();

  useEffect(() => {
    const temp = getNames().map((name) => ({
      label: name,
      value: name,
    }));
    setCountryList(temp);
  }, []);

  const onSubmit = async (data: BroFormData) => {
    if (isSubmitting) return; 
    setIssubmitting(true);
    
    try{
      const response = await articleService.broFormSubmit({
      ...data,
      brand_id: brand_id,
      post_id: post_id,
    });
    let brand_ids = localStorage.getItem("brand_ids")
      ? localStorage.getItem("brand_ids")
      : "";
    let barndArr: any[] = brand_ids ? brand_ids?.split(",") : [];
    barndArr.push(brand_id);
    localStorage.setItem("brand_ids", barndArr.join(","));

    localStorage.setItem(
      "broFormData",
      JSON.stringify({
        ...data,
        brand_id: brand_id,
        post_id: post_id,
      })
    );
    if (response?.success) {
      setIsSubmitted(true);
      window.location.reload();
    }
    } catch (error) {
      console.error("Form submission failed:", error);
    } finally {
      setIssubmitting(false);
    }
  };

  //   const handleSubmit = async (e: React.FormEvent) => {
  //     e.preventDefault();
  //     if (formValid) {
  //       console.log("Form submitted:", formData);
  //       const response = await authService.register(formData);
  //       console.log(
  //         "response=>",
  //         response,
  //         (response as any)?.data,
  //         response?.status
  //       );
  //       if ((response as any)?.success && (response as any)?.data?.messageId) {
  //         console.log("response=>", response);
  //         setShowOTP(true);
  //       }
  //     }
  //   };

  //   const handleOTPVerify = async (otp: string) => {
  //     // Handle OTP verification here
  //     const response = await authService.verifyCreate({ ...formData, otp });
  //     console.log("Verifying OTP:", otp, "for account creation");
  //     if ((response as any)?.success) {
  //       console.log("setSession OTP:", {
  //         ...(response as any)?.data?.newUser,
  //         token: (response as any)?.data?.token,
  //       });
  //       await setSession({
  //         ...(response as any)?.data?.newUser,
  //         token: (response as any)?.data?.token,
  //       });
  //       router.push(`/`);
  //     }
  //     // You would typically send this to your backend for verification
  //   };

  // const handleChangeNumber = () => {
  //   setShowOTP(false);
  // };

  // const getCountryList = async () => {
  //   const responseCountry: any = await authService.getAll(
  //     "get-countrys?status=active"
  //   );
  //   setCountryList((responseCountry as any)?.data?.data || []);
  // };

  // const inputVariants = {
  //   focus: { scale: 1.02, transition: { duration: 0.2 } },
  //   blur: { scale: 1, transition: { duration: 0.2 } },
  // };

  // const labelVariants = {
  //   initial: { opacity: 0, y: 10 },
  //   animate: { opacity: 1, y: 0, transition: { duration: 0.2 } },
  //   exit: { opacity: 0, y: -10, transition: { duration: 0.15 } },
  // };

  const buttonVariants = {
    hover: { scale: 1.02 },
    tap: { scale: 0.98 },
    disabled: { opacity: 0.7 },
  };

  // const formValid =
  //   formData.email &&
  //   formData.mobile &&
    // formData.fname &&
    // formData.lname &&
    // formData.company_name &&
    // formData.designation &&
    // formData.country_name &&
    // formData.is_accept_terms;

  // if (showOTP) {
  //   return (
  //   <div className='min-h-screen overflow-hidden flex flex-col items-center justify-center p-4 w-full'>
  //     <OTPVerification
  //       phoneNumber={formData.mobile}
  //       onVerify={handleOTPVerify}
  //       onChangeNumber={handleChangeNumber}
  //       />
  //       </div>
  //   );
  // }

  return (
    <div className="w-full pt-8 flex flex-col relative">
      {/* <pre>{JSON.stringify(formData, null, 2)}</pre> */}
      <div className="z-9 absolute bg-gradient-to-t from-white from-50% to-white/0 left-0 right-0 -top-48 w-full h-96"></div>
      <div className="z-10">
        <SectionHeading
          title="PARTNER CONTENT"
          bgColor="bg-orange/20"
          textColor="text-orange"
        />
        {/* <div className="w-full py-7 border-b border-border"> */}
        <span className="text-[32px] font-medium text-foreground pb-6">
          Please fill the form below to proceed with this article.
        </span>
        <div className="border-b border-border pt-6"></div>
        {/* </div> */}
        <div className="relative pt-8">
          <form onSubmit={handleSubmit(onSubmit)} className="w-full space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Email */}
              <InputField
                control={control}
                label="Email"
                name="email"
                placeholder="Email *"
                // register={register}
                pattern={{
                  value: /^[^@\s]+@[^@\s]+\.[^@\s]+$/,
                  message: 'Invalid email address',
                }}
                required
                type="email"
                error={errors.email?.message}
              />

              {/* Mobile */}
              <InputField
                label="Mobile"
                name="mobile"
                placeholder="Mobile *"
                control={control}
                required
                type="text"
                pattern={{
                  value: /^[0-9]{10,}$/,
                  message: 'Enter a valid mobile number (minimum 10 digits)'
                }}
                error={errors.mobile?.message}
              />

              {/* First Name */}
              <InputField
                label="First Name"
                name="fname"
                placeholder="First Name"
                control={control}
                pattern={{
                  value: /^[a-zA-Z\s]*$/,
                  message: 'First name should only contain letters'
                }}
                error={errors.fname?.message}
              />

              {/* Last Name */}
              <InputField
                label="Last Name"
                name="lname"
                placeholder="Last Name"
                control={control}
                pattern={{
                  value: /^[a-zA-Z\s]*$/,
                  message: 'Last name should only contain letters'
                }}
                error={errors.lname?.message}
              />

              {/* Company Name */}
              <InputField
                label="Company Name"
                name="company_name"
                placeholder="Company Name"
                control={control}
                error={errors.company_name?.message}
              />

              {/* Designation */}
              <InputField
                label="Position"
                name="designation"
                placeholder="Position"
                control={control}
                error={errors.designation?.message}
              />

              {/* Country */}
              <div>
                <Select
                  name="country_name"
                  options={countryList}
                  value={countryList.find(
                    (opt: any) => opt.value === values.country_name
                  )}
                  onChange={(selectedOption: any) => {
                    setValue("country_name", selectedOption?.value || "", { 
                      shouldValidate: true 
                    });
                  }}
                  className="w-full text-sm"
                  classNamePrefix="react-select"
                  placeholder="Select Country *"
                  isSearchable
                  required
                />
                {errors.country_name && (
                  <p className="text-xs text-red-500 mt-1">{errors.country_name.message}</p>
                )}
              </div>
            </div>

            {/* Checkboxes */}
            <motion.div
              className="space-y-4"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.3, duration: 0.5 }}
            >
              <motion.label
                className="flex items-center space-x-3"
                whileHover={{ scale: 1.01 }}
                whileTap={{ scale: 0.99 }}
              >
                <input
                  type="checkbox"
                  {...register('is_subscribe_news_letter')}
                  className="w-4 h-4 text-white accent-orange border-gray-300 rounded-xl focus:ring-orange"
                />
                <span className="text-foreground font-medium text-xs">
                  I agree to subscribe to your weekly newsletter
                </span>
              </motion.label>

              <motion.label
                className="flex items-center space-x-3"
                whileHover={{ scale: 1.01 }}
                whileTap={{ scale: 0.99 }}
              >
                <input
                  type="checkbox"
                  {...register('is_accept_terms', {
                    required: 'You must accept terms and conditions'
                  })}
                  className="w-4 h-4 text-white accent-orange border-gray-300 rounded-xl focus:ring-orange"
                />
                <span className="text-foreground font-medium text-xs">
                  I agree and accept all{" "}
                  <Link href="/terms-and-conditions" className="text-borderGray underline" prefetch={false}>
                    terms and conditions
                  </Link>{" "}
                  and{" "}
                  <Link href="/privacy-and-policy" className="text-borderGray underline" prefetch={false}>
                    privacy policies
                  </Link>
                </span>
              </motion.label>
              {errors.is_accept_terms && (
                <p className="text-xs text-red-500">{errors.is_accept_terms.message}</p>
              )}
            </motion.div>

            {/* Submit Button */}
            <motion.button
              type="submit"
              className={`px-24 py-3 rounded-md transition-colors ${
                isValid && !isSubmitting  
                  ? "bg-orange text-white font-medium"
                  : "bg-gray-200 text-gray-700 hover:bg-gray-300"
              }`}
              whileHover={isValid && !isSubmitting ? "hover" : "disabled"}
              whileTap={isValid && !isSubmitting ? "tap" : "disabled"}
              variants={buttonVariants}
              disabled={!isValid || isSubmitting}
            >
              {isSubmitting ? "Submitting..." : "SEND DETAILS"}
            </motion.button>
          </form>
        </div>
      </div>
    </div>
  );
}
